module.exports = __webpack_public_path__ + "img/title-card.636796b0.png";